import React from 'react';

import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, GridToolbarContainer, } from '@mui/x-data-grid';
import { Box, Stack, TextField } from '@mui/material';
import { genURL } from '../../_getjson';
import CustomInput from '../CustomInput/CustomInput';
import CustomInputSearch from '../CustomInput/CustomInputSearch';
export default function ProductListData(props) {


    const [loading, setLoading] = React.useState(true)
    const [data, setData] = React.useState([])
    const [selectionModel, setSelectionModel] = React.useState([]);

    const [searchData, setSearchData] = React.useState("")

    // const rows = [
    //     { id: 1, code: 'Hello', name: 'World' },
    //     { id: 2, code: 'DataGridPro', name: 'is Awesome' },
    //     { id: 3, code: 'MUI', name: 'is Amazing' },
    // ];

    React.useEffect(() => {
        getData();
        return () => {
        }
    }, [])


    React.useEffect(() => {
        getData();
        return () => {
        }
    }, [searchData])


    const getData = async () => {

        let rows = []
        setLoading(true)
        let url = ""
        if (searchData !== "") {
            url = "CSPRODUCT/GETSearchproduct?checkCODE=true&checkNAMETH=true&txt=" + searchData
        }
        else {
            url = "CSPRODUCT/All?top=100"
        }
        await axios.get(genURL(url)).then(e => {
            console.log("getData", e);

            for (let index = 0; index < e.data.length; index++) {
                rows.push({
                    id: index + 1,
                    code: typeof e.data[index].CODE === "undefined" ? e.data[index].PRODUCTCODE : e.data[index].CODE,
                    name: typeof e.data[index].NAMETH === "undefined" ? e.data[index].PRODUCTNAME : e.data[index].NAMETH,
                    unitCode: typeof e.data[index].STOCKUNIT === "undefined" ? e.data[index].STOCKUNIT : e.data[index].STOCKUNIT
                })
            }
        })
        await console.log(rows);
        await setLoading(false)
        await setData(rows)
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'code',
            headerName: 'รหัสสินค้า',
            width: 30,
            editable: false,
            flex: 1
        },
        {
            field: 'name',
            headerName: 'ชื่อ/คำอธิบาย',
            width: 150,
            editable: false,
            flex: 1
        },
        {
            field: 'unitCode',
            headerName: 'unitCode',
            width: 150,
            editable: false,
            flex: 1
        },
    ];

    const handleDoubleClick = async (e) => {
        // console.log("handleDoubleClick", e);
        // f
        let result = []
        if (selectionModel.length > 0) {
            result = await data.filter((elem) => {
                return selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            await result.push(e.row)
        }

        console.log("result", result)
        await props.resultData(result)
    }

    const searchInput = (e) => {
        setSearchData(e)
    }

    const inputResultData = (e) => {
        console.log(e);
        // if (e.key === "Enter") {
        setSearchData(e)
        // }
    }
    //MuiInputBase-input
    const CustomToolbar = () => {
        return (
            <>
                <GridToolbarContainer id={`GridToolbarContainers`} >

                    <Stack direction="row" spacing={2}>
                        <CustomInputSearch
                            label={"คำค้นหา"}
                            placeholder={'คำค้นหาข้อมูลของท่าน'}
                            resData={e => inputResultData(e)}
                            handelClickButton={e => searchInput(e)}
                            handelKeyDown={e => searchInput(e)}
                        />

                    </Stack>
                </GridToolbarContainer >
            </>
        );
    }


    return (

        <Box sx={{ height: 400, width: '100%', mt: 2 }}>
            {loading == true ? "กำลังโหลด..." :
                <DataGrid
                    rows={data}
                    columns={columns}
                    sx={{
                        fontFamily: "Customfont !important"
                    }}
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                        // filter: {
                        //     filterModel: {
                        //         items: [],
                        //         quickFilterValues: ['quick', 'filter'],
                        //     },
                        // },
                    }}
                    pageSizeOptions={[10]}
                    // checkboxSelection
                    // disableSelectionOnClick
                    // onSelectionModelChange={(newSelectionModel) => {
                    //     setSelectionModel(newSelectionModel);
                    // }}
                    selectionModel={selectionModel}
                    onRowDoubleClick={e => handleDoubleClick(e)}
                    //  onRowClick={e => handleClick(e)}
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{
                        Toolbar: CustomToolbar,
                        // LoadingOverlay: LinearProgress,
                    }}
                />}
        </Box>

    )

}